module.exports = __webpack_public_path__ + "static/media/Asset-18.7a036cd2.svg";